import React from 'react';
import { motion } from 'framer-motion';
import { CatalogCard } from './CatalogCard';
import { catalogProducts } from '../../data/catalog';
export function Catalog() {
  return <section id="productos" aria-labelledby="catalogo-title" className="relative w-full border-t border-ink/[0.07] bg-paper-alt py-28 sm:py-32 lg:py-40" data-id="element-43" data-mp="2i5kjhafw6yk6">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-44" data-mp="2n2javl868reo">
        <div className="mx-auto max-w-2xl text-center" data-id="element-45" data-mp="286llqmwo0nby">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-46" data-mp="2d67yywchu3kr">
            Catálogo
          </p>
          <h2 id="catalogo-title" className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[2.6rem]" data-id="element-47" data-mp="1z7qfxbxj9f96">
            Encontrá el ebook <span className="gradient-text" data-id="element-48" data-mp="3tkg91rg2ukfi">ideal para vos</span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[16px] font-light leading-relaxed text-ink-soft" data-id="element-49" data-mp="2e52xgw7mthb">
            Recursos prácticos creados para aprender, emprender y convertir
            nuevas ideas en proyectos reales.
          </p>
        </div>

        <ul className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-20 lg:grid-cols-3 lg:gap-7" data-id="element-50" data-mp="1rsfxgh2f6e93">
          {catalogProducts.map((product, i) => <motion.li key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: Math.min(i, 5) * 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-51" data-mp="20lj4a6ik7sur" data-mpi={i}>
              <CatalogCard product={product} data-id="element-52" data-mp="1hurreuzd5kbm" />
            </motion.li>)}
        </ul>
      </div>
    </section>;
}